// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__VWMFk","selected":"Sidebar_selected__ceBvG"};